// BNB
export const DEFAULT_INPUT_CURRENCY = 'ETH'
// USDT
export const DEFAULT_OUTPUT_CURRENCY = '0x2774eF7918F6947560FD7128878Cfee3F34535e6'
